import React, { useState } from 'react';
import PhotoBooth from '../photobooth/PhotoBooth';
import WaSendModal from './WaSendModal';

export default function PhotoboothPage({ onBack, onCapture: onCaptureParent }) {
  const [photos, setPhotos] = useState([]);
  const [lastPhoto, setLastPhoto] = useState(null);
  const [showWa, setShowWa] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);

  const handleCapture = (url) => {
    setPhotos(p => [...p, url]);
    setLastPhoto(url);
    onCaptureParent?.(url);
  };

  if (showWelcome) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'var(--bg)', padding: 24, transition: 'background 0.3s',
      }}>
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20, maxWidth: 340, width: '100%' }}>
          <div style={{ fontSize: 72, lineHeight: 1 }}>📸</div>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(2.5rem,10vw,4rem)', fontWeight: 700, color: 'var(--text)', lineHeight: 1.15, margin: 0 }}>
            Nof's<br /><em>Photobooth</em>
          </h1>
          <p style={{ color: 'var(--text-dim)', fontSize: 14, lineHeight: 1.7, fontFamily: "'DM Sans', sans-serif", margin: 0 }}>
            Happy Birthday, Nof! 🎂<br />Foto-foto spesial hanya untuk hari ini.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}>
            <button style={{ width: '100%', padding: '16px', background: 'var(--terra)', border: 'none', borderRadius: 14, color: '#fff', fontWeight: 700, fontSize: 16, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", boxShadow: '0 8px 30px rgba(193,123,90,0.3)' }}
              onClick={() => setShowWelcome(false)}>
              ✨ Mulai Sesi Foto
            </button>
            <button style={{ width: '100%', padding: '14px', background: 'transparent', border: '1px solid var(--border-warm)', borderRadius: 14, color: 'var(--text-dim)', fontSize: 14, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}
              onClick={onBack}>
              ← Kembali ke Terminal
            </button>
          </div>
          <p style={{ color: 'var(--text-faint)', fontSize: 11, fontFamily: "'DM Mono', monospace", letterSpacing: '0.1em', margin: 0 }}>
            from your husband, with love ❤️
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100dvh', background: 'var(--bg)', display: 'flex', flexDirection: 'column', transition: 'background 0.3s' }}>
      {/* Top bar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: 'var(--surface)', borderBottom: '1px solid var(--border)', position: 'sticky', top: 0, zIndex: 50, backdropFilter: 'blur(10px)', transition: 'background 0.3s' }}>
        <button style={{ background: 'transparent', border: 'none', color: 'var(--text-dim)', fontSize: 20, cursor: 'pointer', padding: '4px 8px', lineHeight: 1 }} onClick={onBack}>←</button>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 14 }}>📸</span>
          <span style={{ color: 'var(--text)', fontWeight: 600, fontSize: 15, fontFamily: "'DM Sans', sans-serif" }}>Nof's Photobooth</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {photos.length > 0 && (
            <span style={{ width: 22, height: 22, borderRadius: '50%', background: 'var(--terra)', color: '#fff', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'DM Mono, monospace' }}>
              {photos.length}
            </span>
          )}
          {lastPhoto && (
            <button style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '6px 12px', background: 'rgba(37,160,73,0.15)', border: '1px solid rgba(37,160,73,0.3)', borderRadius: 8, color: '#25A049', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }}
              onClick={() => setShowWa(true)}>
              <WaIco /> WA
            </button>
          )}
        </div>
      </div>

      {/* Strip preview */}
      {photos.length > 0 && (
        <div style={{ background: 'var(--surface)', borderBottom: '1px solid var(--border)', padding: '8px 16px', transition: 'background 0.3s' }}>
          <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 2 }}>
            {photos.map((src, i) => (
              <div key={i} style={{ width: 56, height: 56, flexShrink: 0, borderRadius: 8, overflow: 'hidden', border: '1px solid var(--border-warm)', cursor: 'pointer' }}
                onClick={() => { setLastPhoto(src); setShowWa(true); }}>
                <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Main photobooth */}
      <div style={{ flex: 1, padding: '16px', overflowY: 'auto' }}>
        <PhotoBooth onCapture={handleCapture} mobileMode />
      </div>

      {showWa && lastPhoto && (
        <WaSendModal isOpen onClose={() => setShowWa(false)} imageDataUrl={lastPhoto} />
      )}
    </div>
  );
}

const WaIco = () => (
  <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.787" />
  </svg>
);
